module.exports = __webpack_public_path__ + "media/src/assets/images/comment_customer-8d3c4196395cb32d9ffa501e6b760a01.png";